import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgressSearchPipe } from './progress.module';

@NgModule({
  declarations: [ProgressSearchPipe],
  imports: [CommonModule],
  exports: [ProgressSearchPipe],
})
export class PipeModule {}
